import React, { useEffect, useMemo, useRef } from 'react'
import { Box } from '@mui/material'
import { ReportElementProps } from './ReportElement'
import ReportElementFavorite from './ReportElementFavorite'
import { ReportFavoriteElement } from 'gqlTypes'

const ReportElementText: React.FC<ReportElementProps> = ({
  element,
  report,
  sectionId,
  print,
  onUpdateFavorites,
}) => {
  try {
    const parsedContent = useMemo(
      () => JSON.parse(element.content || 'null'),
      [element.content]
    )
    const containerRef = useRef<HTMLElement>()

    useEffect(() => {
      if (containerRef.current) {
        const tables = containerRef.current.getElementsByTagName('table')
        Array.from(tables).forEach((table) => {
          const isNotSkinny = table.classList.contains('not-skinny')
          const columnLength =
            table.querySelectorAll('tr:last-of-type td').length
          if (columnLength <= 2 && !isNotSkinny) {
            table.classList.add('skinny')
          }
        })
      }
    }, [containerRef])

    if (!print && parsedContent.visibility === 'Print Only') {
      return null
    }
    return (
      <Box
        className="report_content"
        display="block"
        sx={{ width: print ? '1200px' : '100%' }}
      >
        {!parsedContent.chart_intro && !print && (
          <Box px={4} display="flex" justifyContent="flex-end" width="100%">
            <ReportElementFavorite
              id={element.id}
              type={ReportFavoriteElement.Element}
              report={report}
              sectionId={sectionId}
              element={element}
              onUpdate={onUpdateFavorites}
            />
          </Box>
        )}
        <Box
          display="block"
          ref={containerRef}
          sx={{ width: print ? '1200px' : '100%', breakInside: 'avoid' }}
          p={print ? 0 : 4}
          pt={0}
          pb={print ? 4 : 0}
          className="text-element"
          dangerouslySetInnerHTML={{ __html: parsedContent.content || '' }}
        />
      </Box>
    )
  } catch (error) {
    console.error(error)
    return null
  }
}

export default ReportElementText
